export default __webpack_public_path__ + "static/media/frame_27_delay-0.05s.2a8f31d5.gif";